import type { SVGProps } from 'react';

export const Close = (props: SVGProps<SVGSVGElement>) => (
  <svg height={12} role="img" width={12} {...props}>
    <title>{'close'}</title>
    <path d="M12 .9l-.9-.9L6 5.1.9 0 0 .9 5.1 6 0 11.1l.9.9L6 6.9l5.1 5.1.9-.9L6.9 6z" />
  </svg>
);
